export default __webpack_public_path__ + "static/media/umesh_basnet.7f04428d.jpg";